define('home/views/CompleteOnboardingView',[
    'underscore',
    'backbone-marionette',

    'home/mixins/withOnboarding',
    'home/templates/completeOnboarding',
], function (
    _,
    Marionette,

    withOnboarding,
    completeOnboardingTemplate
) {
    'use strict';

    /**
     * Shows messaging to user when they have completed onboarding.
     * Messages and icons are shown/hidden/changed in a step-by-step
     * flow, where the steps are transitioned on timers.
     */
    var CompleteOnboardingview = Marionette.ItemView.extend({
        template: completeOnboardingTemplate,
        templateHelpers: function () {
            var channelsFollowing = this.getChannelsFollowing();
            var channelData = this.getChannelsForRender(channelsFollowing);

            return {
                isEnglish: window.document.documentElement.lang === 'en',
                channels: channelData,
                overflowCount: Math.max(
                    channelsFollowing.length - this.constructor.NUM_CHANNELS_SHOWN,
                    0),

                // The steps during which the list of channels shows.
                channelsShownSteps: _.range(
                    this.constructor.ACTIVATE_CHANNEL_LIST_STEP,
                    this.constructor.ACTIVATE_CHANNEL_LIST_STEP + this.constructor.NUM_CHANNELS_SHOWN + 1
                ).join(' '),
            };
        },

        /**
         * Returns a subset of given channels, as many as is specified in class constants.
         * Each channel is returned along with the steps numbers that channel should
         * appear active for.
         *
         * @param {Backbone.Collection} channels A Backbone Collection of Forum models
         *                                       that have a Channel model relation.
         *
         * @returns {Object[]} Each returned item is an object of the form:
         *                     channel - The JSON of the followed channel
         *                     steps - A space separated string listing the
         *                             steps during which this channel should appear as active.
         */
        getChannelsForRender: function (channels) {
            var self = this;
            return _.chain(channels)
                .first(this.constructor.NUM_CHANNELS_SHOWN)
                .map(function (forum, index) {
                    return {
                        channel: forum.channel.toJSON(),

                        // The first channel is activated on the step after the step
                        // that activated the list of channels.
                        // Each subsequent step is activated in turn.
                        // Once a step has been activated it remains active for the
                        // rest of the channel activation steps.
                        steps: _.range(
                            index + self.constructor.ACTIVATE_CHANNEL_LIST_STEP + 1,
                            self.constructor.ACTIVATE_CHANNEL_LIST_STEP + self.constructor.NUM_CHANNELS_SHOWN + 1
                        ).join(' '),
                    };
                })
                .value();
        },

        onShow: function () {
            this.activateSteps(1);
        },

        /**
         * Activates the given step for the length of time specified by
         * data attrs before queuing up the activation of the next step.
         * When there are no steps left, triggers completion.
         *
         * @param {number} curStep - Which step the messaging is currently on.
         *                           Only elements that show for this step will
         *                           receive an active class.
         */
        activateSteps: function (curStep) {
            this.$('[data-steps]').removeClass('active');
            var $curElements = this.$('[data-steps~=' + curStep + ']');

            if (!$curElements.length) {
                this.trigger('complete');
                return;
            }

            $curElements.addClass('active');
            var duration = this.$('[data-steps~=' + curStep + '][data-duration]').attr('data-duration') ||
                this.constructor.DEFAULT_STEP_DURATION;

            _.delay(_.bind(this.activateSteps, this, curStep + 1), duration);
        },
    }, {
        // The amount of time for a step to remain active if that time is
        // not specified in the DOM.
        DEFAULT_STEP_DURATION: 1000,

        // The step during which the list of channels is activated.
        ACTIVATE_CHANNEL_LIST_STEP: 2,

        // The number of channels to show. If more channel are followed,
        // the overflow count is shown.
        NUM_CHANNELS_SHOWN: 3,
    });

    withOnboarding.call(CompleteOnboardingview.prototype);

    return CompleteOnboardingview;
});

